import { ISpreadsheet } from "../types";
import { fetchFile } from "./main";

export class FileProxy {
	private _xlsxWorker: Worker;
	private _spreadsheet: ISpreadsheet;

	constructor(spreadsheet: ISpreadsheet) {
		this._spreadsheet = spreadsheet;
	}

	load(type: "xlsx" | "json" = "xlsx", url?: string): Promise<any> {
		return new Promise(res => {
			this._getFile(type, url).then(file => {
				if (type === "json") {
					return res(file)
				}
				if (file instanceof ArrayBuffer) {
					file = new Uint8Array(file);
				}
				const path = this._spreadsheet.config.importModulePath;

				const xlsxWorker = this._getXlsxWorker(path);

				xlsxWorker.postMessage({
					type: "convert",
					data: file,
					formulas: true,
				});

				xlsxWorker.onmessage = e => {
					if (e.data.type === "ready") {
						res(e.data);
					}
				};
			});
		});
	}

	private _getXlsxWorker(path?: string): Worker {
		if (!this._xlsxWorker) {
			const url = window.URL.createObjectURL(
				new Blob([`importScripts('${path}');`], { type: "text/javascript" })
			);

			this._xlsxWorker = new Worker(url);
		}
		return this._xlsxWorker;
	}

	private _getFile(type: "xlsx" | "json" = "xlsx", url?: string) {
		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		return new Promise(res => {
			if (url) {
				return fetchFile(url, "GET", "arraybuffer").then(data => {
					res(data);
				});
			} else {
				const input = document.createElement("input");
				input.type = "file";
				input.accept = `.${type}`;
				input.click();
				input.addEventListener("change", e => {
					const reader = new FileReader();
					reader.onload = () => {
						const result = reader.result as any;
						res(type === "json" ? result : new Uint8Array(result));
					};
					if (type === "json") {
						reader.readAsText((e as any).target.files[0]);
					} else {
						reader.readAsArrayBuffer((e as any).target.files[0]);
					}
				});
			}
		});
	}
}
